import type { ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'

const SkeletonItem = (): ReactNode => <Skeleton className="h-11 lg:min-w-[140px]" />

const TemplatesCategorySkeleton = (): ReactNode => (
  <div className="row-start-2 flex flex-col gap-3 lg:w-fit">
    <SkeletonItem />
    <div className="hidden flex-col gap-3 lg:flex lg:w-fit">
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
    </div>
  </div>
)

export default TemplatesCategorySkeleton
